function Materials() {
  return (
    <>
      <div style={{width:'100%'}} className="materials-scroll"></div>

      <div className="container materials">
        <h2 className="main-title text-center">МАТЕРИАЛЫ</h2>
        <p className="main-p">
          Материалы конференции находятся по следующей <a title="Materials" href="https://github.com/imconfde/8br-materials" target="_blank" rel="noopener noreferrer">ссылке</a>.
        </p>
      </div>
    </>
  );
}
export default Materials;
